/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const NoNotificationsIcon = () => {
  return (
    <svg width="57" height="64" viewBox="0 0 57 64" fill="none" xmlns="http://www.w3.org/2000/svg" test-id="ss-XdynH">
           <path d="M26.2619 63.5C29.8042 63.5 32.7024 60.5923 32.7024 57.0385H19.8214C19.8214 60.5923 22.7197 63.5 26.2619 63.5ZM26.2619 13.4231C34.2803 13.4231 39.1429 19.9492 39.1429 27.9615V28.2846L45.5834 34.7462V27.9615C45.5834 18.0431 40.3344 9.74 31.0923 7.54308V5.34615C31.0923 2.66462 28.9347 0.5 26.2619 0.5C23.5891 0.5 21.4316 2.66462 21.4316 5.34615V7.54308C20.6587 7.73692 19.9181 8.02769 19.2096 8.28615L24.4908 13.5846C25.0704 13.52 25.6501 13.4231 26.2619 13.4231ZM5.04054 3.24615L0.5 7.80154L9.54888 16.88C7.87435 20.1108 6.94048 23.8908 6.94048 27.9615V44.1154L0.5 50.5769V53.8077H46.3562L51.9595 59.4292L56.5 54.8738L5.04054 3.24615ZM39.1429 47.3462H13.381V27.9615C13.381 25.7646 13.7674 23.6969 14.4758 21.8231L39.1429 46.5708V47.3462Z" fill="#9A9A9A" test-id="P6eWDqPR" />
        </svg>);


};

export default NoNotificationsIcon;